import React from "react"
// import Logo from '../images/sub_logo.png'
import Logo from '../images/fe_logo.png'
import { Link } from 'react-router-dom'
import history from '../history'

import './LogoIcon.css'

export default function LogoIcon({isLightMode}) {
    const handleClick = () => {
        history.push('/')
    }

    return (
        <Link to="/" onClick={handleClick} className={`logoContainer ${isLightMode ? 'logoContainer-dark':''}`}>
           <img style={{paddingTop:'5px',marginLeft:"-35px",marginRight:"-30px"}} width={295}    src={Logo} alt='' className='sub-logo' />
        </Link>
    )
}